$(document).ready(function () {
  $('.partners-slider__inner').slick({
    // dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 8,
    slidesToScroll: 1,
    arrow: true,
    dots: false,
    prevArrow: '<div class="partners-prev"></div>',
    nextArrow: '<div class="partners-next"></div>',
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
        // centerMode: true,
      }
    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
        dots: false,
        infinite: true
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
        infinite: true
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000
      }
    }]
  });
  $('.culture__slider').slick({
    dots: true,
    infinite: true,
    speed: 500,
    // fade: true,
    // cssEase: 'linear'
    prevArrow: '<div class="culture__slider-prev"></div>',
    nextArrow: '<div class="culture__slider-next"></div>'
  });
});